import { graphql } from "@/gql";

export const pendingInvoicesQuery = graphql(`
  query PendingInvoices($supplierId: ID) {
    invoices(
      first: 10
      status: [ISSUED, OVERDUE]
      supplier_id: $supplierId
      orderBy: [{ column: DUE_DATE, order: ASC }]
    ) {
      data {
        id
        reference
        due_date
        amount_due
        currency
        status
        customer_url
        payee {
          id
          name
        }
      }
    }
  }
`);
